import { render, staticRenderFns } from "./BlogCarousel.vue?vue&type=template&id=8d1313cc"
import script from "./BlogCarousel.vue?vue&type=script&lang=ts"
export * from "./BlogCarousel.vue?vue&type=script&lang=ts"
import style0 from "./BlogCarousel.vue?vue&type=style&index=0&id=8d1313cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports